import * as React from "react";
import Box from "@mui/material/Box";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import Sidebar from "../../components/Sidebar";
import theme from "../../theme";
import SkillMappings from "./SkillMappings/SkillMappings";
import SkillMappingsEdit from "./SkillMappingsEdit/SkillMappings";
import ErrorsAndExceptions from "./ErrorsAndExceptions/ErrorsAndExceptions";
import ProcessLog from "./ProcessLog/ProcessLog";
import UserActivityLog from "./UserActivityLog/UserActivityLog";
export default function App() {
  const [open, setOpen] = React.useState(true);
  const toggleDrawer = () => {
    setOpen(!open);
  };

  return (
    <BrowserRouter>
      <Box sx={{ display: "flex" }}>
        <Sidebar open={open} handleDrawerClose={toggleDrawer} />
        <Box
          component="main"
          sx={{
            backgroundColor: theme.palette.grey[100],
            flexGrow: 1,
            height: "100vh",
            overflow: "auto",
          }}
        >
          <Box sx={{ m: 4 }}>
            <Routes>
              <Route path="skill-mappings" element={<SkillMappings />} />
              <Route
                path="/skill-mappings/edit/:id"
                element={<SkillMappingsEdit />}
              />
              <Route path="/process-log" element={<ProcessLog />} />
              <Route
                path="/errors-exceptions"
                element={<ErrorsAndExceptions />}
              />
              <Route path="/user-activity-log" element={<UserActivityLog />} />
            </Routes>
          </Box>
        </Box>
      </Box>
    </BrowserRouter>
  );
}
